import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'

export default function configureStore(initialState) {
  const logger = createLogger()
  const store = createStore(
    rootReducer, 
    initialState,
    applyMiddleware(thunk, logger))

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers')
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}


// WEBPACK FOOTER //
// ./src/store/configureStore.js